<template>
    <div class="text-md-center">
        <v-avatar color="teal darken-3" size="128">
            <v-img v-if="profileImage" :src="profileImage"></v-img>
            <v-icon v-else color="white" x-large>mdi-account</v-icon>
        </v-avatar>
        <v-dialog v-model="changeImageDialog" persistent max-width="300">
            <template #activator="{ on }">
                <v-btn v-on="on" text class="ml-4 ml-md-0 mt-0 mt-md-4">
                    <v-icon left>mdi-image-edit-outline</v-icon>
                    Ganti foto
                </v-btn>
            </template>

            <v-card>
                <v-card-title>Ganti foto</v-card-title>
                <v-card-text>
                    <v-file-input
                        v-model="image"
                        label="Pilih foto"
                        prepend-icon="mdi-image"
                        @change="imageChange"
                    ></v-file-input>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="changeImageDialog = false" text>Batal</v-btn>
                    <v-btn
                        @click="submit"
                        type="submit"
                        text
                        color="primary"
                        :loading="$store.get('loader/loading', 'imageUpload')"
                        :disabled="! image || compressing"
                    >
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { get } from 'vuex-pathify'
import imageCompression from 'browser-image-compression'
import createFormData from '@/tools/createFormData'

const ONE_MEGABYTE = 1048576

export default {
    data() {
        return {
            changeImageDialog: false,
            image: null,
            compressing: true,
        }
    },

    computed: {
        profileImage: get('auth/image'),
    },

    watch: {
        changeImageDialog(to) {
            if (to) {
                this.compressing = true
                this.image = null
            }
        }
    },

    methods: {
        imageChange() {
            if (!! this.image && this.image.size > ONE_MEGABYTE) {
                imageCompression(this.image, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 2000,
                    useWebWorker: false,
                })
                .then(compressed => {
                    this.image = compressed
                    this.compressing = false
                })
            } else {
                this.compressing = false
            }
        },

        submit() {
            const data = createFormData({
                '_method': 'PUT',
                image: this.image
            })

            this.$api.post('auth/image', data, { loader: 'imageUpload' })
                .then(response => {
                    if (response.data.updated) {
                        return this.$api.get('auth', { loader: 'imageUpload' })
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
                .then(response => {
                    this.$store.set('auth/image', response.data.image)

                    this.$store.dispatch('flash/info', 'Foto diubah')
                    this.changeImageDialog = false
                })
        },
    },
}
</script>
